export default "__VITE_ASSET__DNuth2BX__"